<template>
  <p class="item-description-text">
    <TextWithLinks :text="text" link-class="item-description-text__link" />
  </p>
</template>

<script>
import TextWithLinks from '../text/TextWithLinks.vue'

export default {
  name: 'ItemDescriptionText',
  components: {
    TextWithLinks
  },
  props: {
    text: {
      type: String,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
.item-description-text {
  @extend %body;
  white-space: pre-wrap;
  line-height: 1.6;
  letter-spacing: 0.28px;

  &__link {
    color: $link;
    word-break: break-all;
  }
}
</style>
